import {LABELS} from '../constants'

export function blockedCommentingReason(isRepoArchived: boolean, isReferenceLocked: boolean) {
  return isRepoArchived
    ? LABELS.repoArchived
    : isReferenceLocked
      ? LABELS.issueLockedToCollaborators
      : LABELS.canNotCommentOnIssue
}
